import { ReactElement } from 'react';
import styles from './common.module.scss';
import { UIIcon } from '../ui-icon';
import { blue } from '../../styles';
import { UIText, UITextProps } from '../ui-text';

type __UISelectOptionItemProps = {
    label: string;
    labelProps?: UITextProps;
    subLabel?: string;
    subLabelProps?: UITextProps;
    selected: boolean;
    disabled: boolean;
    isMulti?: boolean;
    onClick: () => void;
};
export function __UISelectOptionItem(
    props: __UISelectOptionItemProps
): ReactElement {
    const {
        label,
        labelProps,
        subLabel,
        subLabelProps,
        selected,
        disabled,
        isMulti = false,
        onClick
    } = props;
    return (
        <div className={styles.uiSelectOptionItemContainer}>
            <button
                className={styles.uiSelectOptionItemButton}
                onClick={onClick}
                disabled={disabled}
            >
                {!isMulti ? (
                    <div style={{ width: 24, height: 24 }}>
                        {selected && (
                            <UIIcon name="check" size={16} color={blue} />
                        )}
                    </div>
                ) : null}

                <div className={styles.uiSelectOptionItemTextContainer}>
                    <UIText
                        variant="basic"
                        type={
                            disabled
                                ? 'disabled'
                                : selected
                                  ? 'link'
                                  : 'default'
                        }
                        {...labelProps}
                    >
                        {label}
                    </UIText>
                    {subLabel ? (
                        <UIText
                            variant="small"
                            type={
                                disabled
                                    ? 'disabled'
                                    : selected
                                      ? 'link'
                                      : 'default2'
                            }
                            {...subLabelProps}
                        >
                            {subLabel}
                        </UIText>
                    ) : null}
                </div>
            </button>
        </div>
    );
}
